import React, { useEffect, useState, useRef } from "react";
import {Link} from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { useSettings } from '../SettingsContext';
import axios from "axios";

const Header = () => {
    const setting = useSettings();
    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    const [visaTypes,setVisaTypes] = useState([]);
    useEffect(() => {
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_VISA_TYPE;
        axios.get(`${apiBaseUrl}${Url}`)
            .then(response => setVisaTypes(response.data))
            .catch(error => console.error("Error fetching API",error));
    },[]);
    const offcanvasStyle = {
        width: '50%',
    };

    const offcanvasMobileStyle = {
        '@media (max-width: 768px)': {
            width: '200px',
        },
    };
    return (
        <header>
            <header className="header">
                {/*<div className="pb-0 bg-dark">
                    <div className="">
                        <div className="text-white fw-bold">
                            <marquee behavior="" direction="">The website is under development | ওয়েবসাইটটি তৈরির কাজ চলছে</marquee>
                        </div>
                    </div>
                </div>*/}
                <div className="header-top pt-1">
                    <div className="container">
                        <div className="header-top-wrap">
                            <div className="header-top-left">
                                <div className="header-top-list py-3 text-center text-lg-start">
                                    <span className="text-white">অফিস খোলা : {setting?.office_hour}</span>
                                </div>
                            </div>
                            <div className="header-top-right d-grid align-items-center">
                                <div className="header-top-social align-items-center">
                                    <span>Follow Us: </span>
                                    {setting?.facebook && (
                                        <a href={setting?.facebook || '#'} target="_blank" rel="noopener noreferrer">
                                            <i className="fab fa-facebook"></i>
                                        </a>
                                    )}
                                    {setting?.youtube && (
                                        <a href={setting?.youtube || '#'} target="_blank" rel="noopener noreferrer">
                                            <i className="fab fa-youtube"></i>
                                        </a>
                                    )}
                                    {setting?.instagram && (
                                        <a href={setting?.instagram || '#'} target="_blank" rel="noopener noreferrer">
                                            <i className="fab fa-instagram"></i>
                                        </a>
                                    )}
                                    {setting?.tiktok && (
                                        <a href={setting?.tiktok || '#'} target="_blank" rel="noopener noreferrer">
                                            <i className="fab fa-tiktok"></i>
                                        </a>
                                    )}
                                    {setting?.twitter && (
                                        <a href={setting?.twitter || '#'} target="_blank" rel="noopener noreferrer">
                                            <i className="fab fa-linkedin"></i>
                                        </a>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="main-navigation p-0" style={{backgroundColor:'#f3ecea'}}>
                    <nav className="navbar navbar-expand-lg p-0">
                        <div className="container position-relative">
                            <Link className="navbar-brand" to={'/'}>
                                <img style={{width:'140px'}} className={'img-fluid'} src={`${backendBaseUrl}${setting?.logo}`} alt="logo" />
                            </Link>
                            <div className="mobile-menu-right">
                                <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar" aria-label="Toggle navigation">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </button>
                            </div>
                            <div className="offcanvas offcanvas-start" data-bs-backdrop="true" style={offcanvasStyle} tabIndex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
                                <div className="offcanvas-header">
                                    <Link className="offcanvas-brand" id="offcanvasNavbarLabel" to={'/'}>
                                        <img src={`${backendBaseUrl}${setting?.logo}`} alt="logo"/>
                                    </Link>
                                    <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close">
                                        <i className="far fa-xmark"></i>
                                    </button>
                                </div>
                                <div className="offcanvas-body">
                                    <ul className="navbar-nav justify-content-end flex-grow-1">
                                        <li className="nav-item dropdown">
                                            <NavLink
                                                className={({ isActive }) => `nav-link fs-6 ${isActive ? 'active' : ''}`}
                                                to="/"
                                            >
                                                হোম
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                                                to="/about-us"
                                            >
                                                আমাদের সম্পর্কে
                                            </NavLink>
                                        </li>
                                        <li className="nav-item dropdown">
                                            <NavLink
                                                className={({ isActive }) => `nav-link dropdown-toggle ${isActive ? 'active' : ''}`}
                                                to="/visa"
                                                data-bs-toggle="dropdown"
                                            >
                                                ভিসা
                                            </NavLink>
                                            <ul className="dropdown-menu fade-down">
                                                <li>
                                                    <Link className="dropdown-item" to={'/visa'}>
                                                        সব ভিসা
                                                    </Link>
                                                </li>
                                                {visaTypes.map((visaType, index) => {
                                                    return (
                                                        <li key={index}>
                                                            <Link className="dropdown-item" to={`/visa/${visaType.slug}`}>
                                                                {visaType?.name}
                                                            </Link>
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                                                to="/blogs"
                                            >
                                                ব্লগ
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                                                to="/contact-us"
                                            >
                                                যোগাযোগ
                                            </NavLink>
                                        </li>
                                    </ul>

                                    <div className="nav-right">
                                        <div className="search-btn">
                                            <span className="fw-bold">কল করুন</span>
                                            <br />
                                            <span className="fw-bold">{setting?.header_phone}</span>
                                        </div>
                                        <div className="nav-btn">
                                            <Link className="theme-btn text-decoration-none" to={'/contact-us'}>
                                                সাপোর্ট <i className="fas fa-circle-arrow-right"></i>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>
            </header>
        </header>
    );
}

export default Header;